
<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card z-index="1"
        v-if="step && step.id" 
        @click.native.stop="edit()" 
        :style="{border: `${$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].secondary} 2px solid`, borderRadius: '15px'}" 
        class="mb-2"
      >
        <v-card-text 
          style="background-color: #FFC54D !important" 
          class="pa-3 text-center" 
          v-if="step.kind == 'divisor'"
        >
          <span class="black--text font-weight-bold">
            {{step.name}}
          </span>
          <template v-if="hover && one_flow.status == 'draft'" >
            <div class="text-right" style="position: relative; top: -4px; height: 0px;">
              <v-chip small pill color="secondary" class="mx-2"  @click.stop="duplicate()">
                <v-avatar left>
                  <v-icon small>mdi-content-copy</v-icon>
                </v-avatar>
                Clonar
              </v-chip>
              <v-chip small pill color="secondary" class="mx-2" @click.stop="open_new_dialog = true">
                <v-avatar left>
                  <v-icon >mdi-plus</v-icon>
                </v-avatar>
                Etapa
              </v-chip>
            </div>
          </template>
        </v-card-text>
        <v-card-text 
          class="pa-3" 
          v-if="step.kind != 'divisor'"
        >
          <v-row align="center" class="px-3">
            <span v-if="step.id" class="mr-2">
              {{idx+1}}.
            </span>
            <span 
              v-if="step.id" 
              :class="`font-weight-bold ${$vuetify.theme.isDark ? 'white--text' : 'black--text'}`"
            >
              {{step.name}}
            </span>
          </v-row>
          <v-row align="center" class="px-3 pt-2">
            <v-avatar size="24" :color="kind_text_map[step.kind].color_selected" >
              <v-icon size='18' color='black'>{{kind_text_map[step.kind].icon}}</v-icon>
            </v-avatar>
            <span :class="`ml-2 ${$vuetify.theme.isDark ? 'white--text' : 'black--text'}`">{{kind_text_map[step.kind].text}}</span>

            <template v-if="hover && one_flow.status == 'draft'">
              <v-spacer></v-spacer>
              <!-- <v-btn x-small fab class="elevation-0"  color="secondary" >
                <v-icon>mdi-check</v-icon>
              </v-btn> -->
              <v-chip small pill color="secondary" class="mx-2" style="position: relative; top: 20px" @click.stop="duplicate()">
                <v-avatar left>
                  <v-icon small>mdi-content-copy</v-icon>
                </v-avatar>
                Clonar
              </v-chip>
              <v-chip small pill color="secondary" class="mx-2" style="position: relative; top: 20px" @click.stop="open_new_dialog = true">
                <v-avatar left>
                  <v-icon >mdi-plus</v-icon>
                </v-avatar>
                Etapa
              </v-chip>
            </template>
          </v-row>
        </v-card-text>
      </v-card>

    </v-hover>

    <add-step-dialog
      v-if="open_edit_dialog"
      :dialog="open_edit_dialog"
      :step_id="step.id"
      :group_id="group_id"
      @closeStepDialog="handleCloseStepDialog"
    ></add-step-dialog>

    <add-step-dialog
      v-if="open_new_dialog"
      :duplicate_id="duplicate_id"
      :dialog="open_new_dialog"
      :group_id="group_id"
      :between_indexes="[[step.id], step.next]"
      @closeStepDialog="handleCloseStepDialog"
    ></add-step-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import step_kind from "@/_flow/mixins/step_kind.js";

export default {
  name: "StepCard",
  props: {
    idx: {
      type: Number,
      default: 0
    },
    step: {
      type: Object,
    },
    group_id: {
      type: Number,
      default: null
    }
  },
  components: {
    AddStepDialog: () => import('./AddStepDialog.vue'),
  },
  mixins: [step_kind],
  data() {
    return {
      open_edit_dialog: false,
      open_new_dialog: false,
      duplicate_id: null,
    }
  },
  methods: {
    duplicate(){
      this.duplicate_id = this.step.id
      this.open_new_dialog = true;
    },
    handleCloseStepDialog() {
      this.open_edit_dialog = false;
      this.open_new_dialog = false;
      this.duplicate_id = null
    },
    setKind(kind){
      this.step.kind = kind
      this.$refs.naamee.focus()
    },
    cancel(){
      if (!this.step.id)
      this.$emit('cancelCard')
    },
    save() {
      if (this.step.name)
      this.$emit('doneNewCard')
    },
    edit(){
      this.open_edit_dialog = true;
    },
    ...mapActions({
      showStep: "ConfigFlow/showStep"
    })
  },
  computed: {
    ...mapState({
      one_step_to_edit: state => state.ConfigFlow.one_step_to_edit,
      one_flow: state => state.ConfigFlow.one_flow
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.$refs.naamee && this.$refs.naamee.focus();
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>